(() => {
  const root = document.querySelector('[data-tbv-inline-search]');
  if (!root) return;
  const input = root.querySelector('input[name="q"]');
  const form = root.querySelector('form');
  const panel = root.querySelector('[role="listbox"]');
  const clear = root.querySelector('.tbv-inline-search__clear');
  let timer, controller, sequence = 0;
  const close = () => { panel.hidden = true; panel.replaceChildren(); input.setAttribute('aria-expanded','false'); };
  const open = () => { panel.hidden = false; input.setAttribute('aria-expanded','true'); };
  const element = (tag, cls, value) => { const node=document.createElement(tag); node.className=cls; if(value!=null) node.textContent=value; return node; };
  const priceText = (product) => {
    const n = Number(product.price);
    if(!Number.isFinite(n)) return '';
    return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n);
  };
  function render(products, term) {
    panel.replaceChildren();
    if(!products.length) panel.append(element('div','tbv-inline-search__empty','No busts found. Try another name.'));
    products.forEach(p => {
      const link=element('a','tbv-inline-search__result');
      link.href=p.url;
      link.setAttribute('role','option');
      if(p.featured_image?.url || p.image) {
        const img=document.createElement('img');
        img.src=p.featured_image?.url || p.image;
        img.alt='';
        img.loading='lazy';
        link.append(img);
      }
      const details=element('span','tbv-inline-search__details');
      details.append(element('span','tbv-inline-search__name',p.title),element('span','tbv-inline-search__price',priceText(p)));
      link.append(details);
      panel.append(link);
    });
    const more=element('a','tbv-inline-search__more','See all results for “'+term+'”');
    more.href='/search?type=product&q='+encodeURIComponent(term);
    panel.append(more);
    open();
  }
  async function search(term) {
    controller?.abort(); controller=new AbortController(); const ticket=++sequence;
    try {
      const u='/search/suggest.json?'+new URLSearchParams({'q':term,'resources[type]':'product','resources[limit]':'5'});
      const res=await fetch(u,{signal:controller.signal,credentials:'same-origin'});
      if(!res.ok) throw Error('Search unavailable');
      const data=await res.json();
      if(ticket===sequence && input.value.trim()===term) render(data.resources?.results?.products || [],term);
    } catch(err) {
      if(err.name!=='AbortError' && ticket===sequence) close();
    }
  }
  input.addEventListener('input',() => {
    const term=input.value.trim();
    clear.hidden=!term; clearTimeout(timer); controller?.abort(); ++sequence;
    if(term.length<2){close();return;}
    timer=setTimeout(()=>search(term),200);
  });
  input.addEventListener('focus',()=>{if(input.value.trim().length>=2) search(input.value.trim());});
  clear.addEventListener('click',()=>{input.value='';clear.hidden=true;close();input.focus();});
  document.addEventListener('pointerdown',e=>{if(!root.contains(e.target))close();});
  input.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
  form.addEventListener('submit',e=>{if(!input.value.trim())e.preventDefault();});
  // Suppress the old mobile faux-input, if injected by a third-party script.
  // It is hidden by class above; do not alter unrelated search widgets.
})();
